import {Component, ViewChild, OnInit, TemplateRef, EventEmitter, Output } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { ModalService } from '../../../services/modal.service';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TipoInterface } from '../../../model/tipointerface';
import { CadastrosService } from '../../../services/cadastros.service';

@Component({
  selector: 'app-detalhes-tipointerface',
  templateUrl: 'tipointerface-detalhes.component.html'
})
export class TipoInterfaceDetalhesComponent implements OnInit{

  @ViewChild('modaltipointerface', {static: false}) public modaltipointerface: ModalDirective;

  sub: boolean = false;
  _tipointerface: TipoInterface = new TipoInterface();
  @Output() loadtipointerface = new EventEmitter();
  titulo: string = "Novo tipointerface";
  movSubSalvar: Subscription;
  movSubAlterar: Subscription;
  movSub: Subscription;

  constructor(
    private modalService: ModalService,
    private toastr: ToastrService,
    private cadastrosService: CadastrosService) {
  }

  ngOnInit() {

    if(this.sub == false){

      this.sub = true;

      this.modalService.modalDetalhesTipoInterface.subscribe(
        (p: TipoInterface) => {

          if(p == null){
            this.titulo = "Novo Tipo de Interface"
            this._tipointerface = new TipoInterface();
          }else{
            this.titulo = "Editar Tipo de Interface"
            this._tipointerface = p;
          }

          this.limpaModal();

          this.modaltipointerface.show();

        }, error => {
          console.log(error.message);
        }
      );
    }

  }

  hideModal(){
    this.modaltipointerface.hide();
    this.loadtipointerface.emit();
  }

  limpaModal(){
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

  onSubmit(form: NgForm) {

    if (!form.valid) {
      return;
    }

    if(this.titulo == "Editar Tipo de Interface"){
      this.atualizar();
    }else{
      this.salvar();
    }

    form.reset();
  }

  salvar(){

    let objtipointerface = JSON.parse(JSON.stringify(this._tipointerface));

    this.cadastrosService.salvar("tipointerface/insert", objtipointerface).subscribe(
      (result) =>{

        this.toastr.success('Tipo de Interface cadastrado com sucesso!', 'Sucesso!');
        console.log(result);

        this.hideModal();

      },
      error=> {

        this.toastr.error(error.message, 'Erro!');
        console.log(error);

        this.hideModal();
      }

    );



  }

  atualizar(){

    let objtipointerface = JSON.parse(JSON.stringify(this._tipointerface));

    this.cadastrosService.atualizar("tipointerface/update", objtipointerface, objtipointerface.id).subscribe(
      (result) =>{

        this.toastr.success('Tipo de Interface atualizado com sucesso!', 'Sucesso!');
        console.log(result);

        this.hideModal();

      },
      error=> {

        this.toastr.error(error.message, 'Erro!');
        console.log(error);

        this.hideModal();
      }

    );
  }
}
